import type { CardSizeId, Orientation, SlotId } from '../types';

/** The 12 demo images live on Cloudflare Images under this account hash. */
const CDN = 'https://imagedelivery.net/mt6ddPFlr8xjCmAix26mMw';

const url = (slug: string) => `${CDN}/foldcard-demo-${slug}/public`;

export interface ExampleCase {
  id: 'sympathy' | 'wedding' | 'birthday';
  name: string;
  blurb: string;
  cardSizeId: Exclude<CardSizeId, 'custom'>;
  paperSizeId: 'letter' | 'a4';
  orientation: Orientation;
  /** All three demo cases are two-sided. */
  twoSided: boolean;
  /** Front-panel URL — also used as the thumbnail in galleries / chips. */
  thumb: string;
  /** Image URLs per canonical slot. insideLeft / insideRight are still the
   *  keys even in landscape (where they're displayed as inside-top / -bottom). */
  slots: Record<SlotId, string>;
}

export const EXAMPLE_CASES: ExampleCase[] = [
  {
    id: 'sympathy',
    name: 'Pet sympathy',
    blurb: '5×7 portrait · two-sided · warm grey monochrome',
    cardSizeId: '5x7',
    paperSizeId: 'letter',
    orientation: 'portrait',
    twoSided: true,
    thumb: url('01-sympathy-front-dog'),
    slots: {
      front: url('01-sympathy-front-dog'),
      back: url('01-sympathy-back-pawprints'),
      insideLeft: url('01-sympathy-inside-left-face'),
      insideRight: url('01-sympathy-inside-right-face'),
    },
  },
  {
    id: 'wedding',
    name: 'Wedding save-the-date',
    blurb: 'A2 landscape · two-sided · golden Mediterranean palette',
    cardSizeId: 'a2',
    paperSizeId: 'letter',
    orientation: 'landscape',
    twoSided: true,
    thumb: url('02-wedding-front-couple'),
    slots: {
      front: url('02-wedding-front-couple'),
      back: url('02-wedding-back-botanical'),
      insideLeft: url('02-wedding-inside-top-olive'),
      insideRight: url('02-wedding-inside-bottom-rings'),
    },
  },
  {
    id: 'birthday',
    name: 'Birthday',
    blurb: 'Square 5×5 · two-sided · joyful golden hour',
    cardSizeId: 'square5',
    paperSizeId: 'letter',
    orientation: 'portrait',
    twoSided: true,
    thumb: url('03-birthday-front-sparkler'),
    slots: {
      front: url('03-birthday-front-sparkler'),
      back: url('03-birthday-back-confetti'),
      insideLeft: url('03-birthday-inside-left-candle'),
      insideRight: url('03-birthday-inside-right-balloon'),
    },
  },
];

export const exampleById = (id: ExampleCase['id']): ExampleCase | undefined =>
  EXAMPLE_CASES.find((c) => c.id === id);
